<div class="table-responsive">
  <table class="tabla-dias">
    <tbody>
      <tr>
        <td
          class="dia-container-habilitado"
          *ngFor="let fecha of promesas | slice : 0 : 5"
        >
          <div style="color: #00549d" style="padding-top: 5px">
            <p style="font-size: 12px">
              <strong>{{
                fecha.requestedDate | date : 'EEEE' | uppercase
              }}</strong>
            </p>
            <p style="font-size: 12px; margin-top: -15px">
              {{ fecha.requestedDate | date : 'dd-MM' }}
            </p>
            <p *ngIf="fecha.price" style="font-size: 13px; margin-top: -15px">
              <strong>{{ fecha.price | currency }}</strong>
            </p>
            <p *ngIf="!fecha.price" style="font-size: 13px; margin-top: -15px">
              <strong>Gratis</strong>
            </p>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
